import { isPostHogEnabledInBrowser, getPostHogProjectToken } from '@/lib/posthog-enabled';
import { isEmbedSubdomainHost } from '@/lib/subdomain-urls';
import { shouldDropPostHogException } from '@/lib/analytics/posthog-exception-filters';

const EMBED_SESSION_RECORDING_SAMPLE_RATE = 0.1;

// Only initialize PostHog in production with a token — not on localhost dev.
if (typeof window !== 'undefined' && isPostHogEnabledInBrowser()) {
  const token = getPostHogProjectToken();
  if (token) {
    const onEmbedSubdomain = isEmbedSubdomainHost(window.location.hostname);

    import('posthog-js').then((module) => {
      const posthog = module.default;
      posthog.init(token, {
        api_host: '/ingest',
        ui_host: 'https://eu.posthog.com',
        defaults: '2026-01-30',
        capture_exceptions: true,
        debug: false,
        before_send: (event) => {
          if (!event) {
            return null;
          }
          if (event.event === '$exception') {
            const props = event.properties as Record<string, unknown> | undefined;
            if (shouldDropPostHogException(props)) {
              return null;
            }
          }
          return event;
        },
        // Surveys unused — skip lazy-loaded surveys.js (~9 KiB legacy polyfills on LP).
        disable_surveys: true,
        // Session replay: lazy-loaded with posthog-js init (async import), same on `/` and app routes.
        ...(onEmbedSubdomain
          ? {
              session_recording: {
                sampleRate: EMBED_SESSION_RECORDING_SAMPLE_RATE,
              },
            }
          : {}),
      });
    });
  }
}
